import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider, MutationCache } from '@tanstack/react-query';
import App from './App';
import './index.css';

// Erro de qualquer gravação (salvar/apagar) aparece num aviso na tela, em vez de falhar em silêncio.
function avisoErro(msg) {
  const el = document.createElement('div');
  el.textContent = msg;
  el.setAttribute('role', 'alert');
  el.style.cssText = 'position:fixed;top:16px;right:16px;max-width:420px;z-index:2147483647;background:#fef2f2;color:#b91c1c;border:1px solid #fecaca;border-radius:10px;padding:12px 16px;font:14px sans-serif;box-shadow:0 4px 16px rgba(0,0,0,.15);cursor:pointer';
  el.onclick = () => el.remove();
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 9000);
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30000, retry: 1 } },
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      if (mutation.options.onError) return; // quem trata o próprio erro não duplica o aviso
      if (err?.response?.status === 401) return;
      avisoErro(err?.response?.data?.error || err?.response?.data?.message || err?.message || 'Não foi possível concluir a operação.');
    },
  }),
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

if ('serviceWorker' in navigator && !window.__INBASE_NO_PWA__) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        // Detecta nova versão disponível e notifica
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Nova versão disponível — recarrega silenciosamente após 3s
              setTimeout(() => {
                newWorker.postMessage('SKIP_WAITING');
                window.location.reload();
              }, 3000);
            }
          });
        });
      })
      .catch((err) => console.error('[SW] Registro falhou:', err));

    // Garante que após controle mudar o app recarrega com novo SW ativo
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });
  });
}
